import React from 'react';

// Main App component
const DonationCart = () => {
  const cardData = [
    {
      id: 1,
      icon: '../images/groupIcon.png', // Using an emoji as a placeholder for the butterfly icon
      title: 'How It Works for Entrepreneurs', // Updated title
      text: `Aspiring or small business entrepreneurs in different parts of the world apply (via a local CSP) to Share-
Circle with a brief explanation of their business idea or plan. Once submitted, the CSP will contact them
and set up a meeting.The CSP’s job is to establish if the business idea or proposal is a viable and what the entrepreneur needs to
be successful, and the likelihood of the borrower to repay the 0% interest loan. When the business
proposal is ready for action, the entrepreneur’s profile is finalised by the CSP and goes live on the Share-
Circle platform for donors to see and support.`,
    },
    {
      id: 2,
      icon: '../images/moneyIcon.png', // Using an emoji as a placeholder for the building icon
      title: '0% Interest Loans with Ongoing Community Support', // Updated title
      text: `Together with the entrepreneur, the CSP will develop a repayment plan. This plan is developed to be the
least strenuous to the entrepreneur and their growing business, which is why all of Share-Circles loans are
at 0% interest rate. This way, the entrepreneur only repays what they borrowed.For their continuous work and support, CSPs receive a financial contribution of 10% of the entrepreneur’s
loan value. This 10% is paid out in parts at each milestone the entrepreneur’s business plan meets. This
way, the CSP are incentivised to stay engaged and support the entrepreneur on their business journey.`,
    },
    {
      id: 3,
      icon: '../images/handIcon.png', // Using an emoji as a placeholder for the brain icon
      title: 'The Circle That Keeps Giving', // Updated title
      text: `As the entrepreneurs 0% loans are repaid, the money is reinvested in other entrepreneurs’ business plans
and the circle begins again. Although the whole initial donation is being circulated in the Share-Circle
entrepreneur community, additional funding to cover CSP costs are crucial.The CSP’s play a vital role in ensuring the entrepreneur’s business plan stays on track and grows to its full
potential. The CSP’s involvement is what makes Share-Circle different from other microfinance charities,
and they are the linchpin for helping the entrepreneurs succeed and continue the virtuous circleHence, because previous donations are recycled, most loan applications are only looking to crowd fund 80-
60% of their target loan rather than 100%`,
    },
  ];

  return (
    <>
      <div className="container-fluid py-4 min-h-screen bg-gray-100 font-sans flex items-center justify-center">
        {/* A nested Bootstrap container to constrain content width */}
        <div className="container">
          {/* Bootstrap row for the grid layout */}
          <div className="row g-4">
            {cardData?.slice(0, 2).map((card) => (
              <div
                key={card.id}
                // Using Bootstrap column classes for responsiveness
                className="col-12 col-md-12 col-lg-6 mb-4 p-3" // Full width on small, full width on medium, 1/3 width on large, with bottom margin
              >
                <div
                  className="bg-white rounded-lg shadow-sm p-6 h-full flex DonationCart11 text-left"
                  style={{ minHeight: '400px' }} // Keep minimum height for visual consistency
                >
                  <span className="text-4xl me-4 mt-2"><img src={card.icon} alt='' /></span>
                  <div className="flex items-center mb-4 mt-3">
                    {/* Icon placeholder - you can replace this with a proper SVG or image */}
                    <h3 className="text-xl font-semibold text-gray-800">
                      {card.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                      {card.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
            {cardData.filter(card => card.id === 3).map((card) => (
              <div
                key={card.id}
                // Using Bootstrap column classes for responsiveness
                className="col-12 col-md-12 col-lg-6 mb-4 p-3 d-block m-auto" // Full width on small, full width on medium, 1/3 width on large, with bottom margin
              >
                <div
                  className="bg-white rounded-lg shadow-sm p-6 md:h-full flex DonationCart11 text-left"
                  style={{ minHeight: '400px' }} // Keep minimum height for visual consistency
                >
                  <span className="text-4xl me-4 mt-2"><img src={card.icon} alt='' /></span>
                  <div className="flex items-center mb-4 mt-3">
                    {/* Icon placeholder - you can replace this with a proper SVG or image */}
                    <h3 className="text-xl font-semibold text-gray-800">
                      {card.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                      {card.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default DonationCart;
